import {
  DEFAULT_BUTTON_PRESET,
  isButtonSize,
  isButtonTone,
  isButtonVariant,
} from './button-presets';
import type { ButtonPreset } from './button-presets';

/**
 * Turns whatever the composer stored into a complete preset.
 *
 * Tolerant on every axis independently: a value saved by a newer composer, a
 * half-written object, or an outright wrong type costs that one axis and
 * nothing else. A published page must never fail to render a button because
 * one field went stale.
 */
export function resolveButtonPreset(value: unknown): ButtonPreset {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return DEFAULT_BUTTON_PRESET;
  }

  const candidate = value as Partial<Record<keyof ButtonPreset, unknown>>;

  return {
    variant: isButtonVariant(candidate.variant)
      ? candidate.variant
      : DEFAULT_BUTTON_PRESET.variant,
    tone: isButtonTone(candidate.tone) ? candidate.tone : DEFAULT_BUTTON_PRESET.tone,
    size: isButtonSize(candidate.size) ? candidate.size : DEFAULT_BUTTON_PRESET.size,
  };
}
